import React, { useRef, useState, useEffect } from "react";
import "./TextInput.scss";

const TextInput = (props) => {
  const { caption, type, value, onChange, required } = props;
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const inputEl = useRef(null);
  const labelEl = useRef(null);

  useEffect(() => {
    inputEl.current.value = value;
    handleInputFocus();
  }, [value]);

  const handleInputChange = (e) => {
    let value = e.target.value;
    onChange(value);
  };

  const convertToSlug = (Text) => {
    return Text?.toLowerCase()
      .replace(/[^\w ]+/g, "")
      .replace(/ +/g, "-");
  };

  const handleInputFocus = () => {
    labelEl.current.className = "small";
  };

  const handleInputBlur = (e) => {
    let value = e.target.value;
    if (value === "") {
      labelEl.current.className = "big";
    }
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => !prev);
  };

  const getType = () => {
    const allowedTypes = ["text", "date", "email", "number", "password"];
    if (allowedTypes.includes(type)) {
      return type === "password" && isPasswordVisible ? "text" : type;
    } else {
      console.error("Type not supported: " + type);
      return "text";
    }
  };

  return (
    <div className='inputContainer'>
      {type === "password" && (
        <div className='iconContainer' onClick={togglePasswordVisibility}>
          <img
            src={isPasswordVisible ? "../images/icons/eye-closed.svg" : "../images/icons/eye-open.svg"}
            alt={isPasswordVisible ? "Hide password" : "Show password"}
          />
        </div>
      )}
      <input
        autoComplete='off'
        id={convertToSlug(caption)}
        ref={inputEl}
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
        type={getType()}
        onChange={handleInputChange}
        required={required}
      />
      <label htmlFor={convertToSlug(caption)} ref={labelEl}>
        {caption}
      </label>
    </div>
  );
};

export default TextInput;
